import { CacheItem } from '../models/CacheItem'
import { FetchBase } from '../shared/FetchBase'

export class CacheFetch extends FetchBase {
  constructor() {
    super('', '/api/cache')
  }

  getAllCacheItems(): Promise<CacheItem[]> {
    return this.ajaxRequest('GET', '')
  }

  clearCacheItem(cacheKey: string) {
    return this.ajaxRequest('POST', `Clear?cacheKey=${cacheKey}`)
  }

  clearAllCacheItems() {
    return this.ajaxRequest('POST', 'ClearAll')
  }
}
